import { IChangeUsageOrMileageForm } from './get-usage-cover-details';

export const getUsageDetails = (values: IChangeUsageOrMileageForm, baseVehicleDetails: any) => {
	return {
		...baseVehicleDetails,
		vehicleUse: values.vehicleUse || baseVehicleDetails.vehicleUse,
		annualMileage: parseInt(values.annualMileage, 10) || baseVehicleDetails.annualMileage,
		businessMileage: values.businessMileage ? String(values.businessMileage) : baseVehicleDetails.businessMileage,
	};
};
